import React from 'react';
import DatePicker from 'react-datepicker';
import { Icon, Input } from 'components/ui';
import clsx from 'clsx';
import { Parsers } from 'utils';
import 'react-datepicker/dist/react-datepicker.css';
import './datepicker.scss';
import moment from 'moment';

export type DatePickerProps = {
  value: Date | undefined;
  onChange: (value: Date) => void;
  placeholder?: string;
  className?: string;
  label?: string;
  isDisabled?: boolean;
  maxDate?: Date;
  minDate?: Date;
  futureDateNotAllowed?: boolean;
  withLabel?: boolean;
  childClass?: string;
  iconClass?: string;
  name?: string;
  openToDate?: Date;
};

const CustomInput: React.FC<any> = (props) => {
  let { value } = props
  return (
    <Input {...props} value={Parsers.dateInput(value)} placeholder='Required' maxLength={10} />
  )
}

const DatePickerUI: React.FC<DatePickerProps> = ({
  value,
  onChange,
  className,
  children,
  label,
  isDisabled,
  placeholder,
  maxDate,
  minDate,
  futureDateNotAllowed,
  withLabel,
  childClass = '',
  iconClass = '',
  name,
  openToDate,
}) => {
  let inputRef: any;

  let tempMaxDate;
  if (futureDateNotAllowed) tempMaxDate = new Date()
  if (maxDate) {
    if ((tempMaxDate && tempMaxDate.valueOf() > new Date(maxDate).valueOf()) || !tempMaxDate) tempMaxDate = new Date(maxDate)
  }


  const handleIconClick = () => {
    if (inputRef) inputRef.setOpen(true)
  }


  return (
    <div className={clsx('datepicker', className)}>
      {label && <div className="label">{label}</div>}
      <DatePicker
        customInput={<CustomInput />}
        name={name}
        ref={r => inputRef = r}
        disabled={isDisabled}
        selected={value || undefined}
        onChange={onChange}
        showYearDropdown
        showMonthDropdown
        dateFormatCalendar="MMMM"
        placeholderText={placeholder}
        maxDate={tempMaxDate}
        minDate={minDate || new Date(moment().set('year', 1900).set('month', 0).set('date', 1).valueOf())}
        dateFormat="M/d/yyyy"
        className={childClass}
        scrollableYearDropdown={true}
        yearDropdownItemNumber={100}
        openToDate={openToDate}
      />
      <Icon onClick={handleIconClick} className={`icon ${iconClass} ${withLabel ? 'withLabel' : ''}`} name="datepicker" />
      {children}
    </div>
  );
};

export default DatePickerUI;